const Loading = ({ parentClass, childClass, childrenNumber, mode, children, isErr }) => {
    return (
        <div className={`w-full ${parentClass ? parentClass : 'scrolling gap-2'}`}>
            {
                [...Array(childrenNumber)].map((_, index) => (
                    <div className={`${mode === 'd' ? 'darkLoader' : 'l-load'} ${Array.isArray(childClass) ? childClass[index] : childClass}`} key={index}>
                        {children}
                    </div>
                ))
            }
        </div>
    )
}
export default Loading